/* VULGAR:ERRORS — product card interactions + featured drag carousel + micro-motion. */
(function () {
  function closeSheets(except) {
    document.querySelectorAll('.ve-qa.is-open').forEach(function (el) {
      if (el !== except) el.classList.remove('is-open');
    });
  }
  function sectionsFor(target) {
    if (target && typeof target.getSectionsToRender === 'function') {
      return target.getSectionsToRender().map(function (section) { return section.id; });
    }
    return [];
  }
  function addVariant(pill) {
    if (pill.classList.contains('is-busy')) return;
    var target = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    pill.classList.add('is-busy');
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: Number(pill.dataset.veVariant), quantity: 1, sections: sectionsFor(target), sections_url: window.location.pathname }),
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'add failed');
        if (target && typeof target.renderContents === 'function') {
          if (typeof target.open === 'function') { target.classList.remove('is-empty'); }
          target.renderContents(data);
        } else { window.location.href = window.routes.cart_url; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 've-quick-add', cartData: data });
        }
      })
      .catch(function () { window.location.href = window.routes.cart_url; })
      .finally(function () { pill.classList.remove('is-busy'); closeSheets(null); });
  }
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('.ve-qa__pill[data-ve-variant]');
    if (pill && !pill.disabled) { event.preventDefault(); event.stopPropagation(); addVariant(pill); return; }
    var plus = event.target.closest('[data-ve-qa-toggle]');
    if (plus) {
      event.preventDefault(); event.stopPropagation();
      var media = plus.closest('.ve-card__media');
      var qa = media ? media.querySelector('.ve-qa') : null;
      closeSheets(qa);
      if (qa) qa.classList.toggle('is-open');
      return;
    }
    if (!event.target.closest('.ve-qa') && !event.target.closest('a')) {
      var card = event.target.closest('.ve-card');
      var link = card && card.querySelector('.ve-card__link[href]');
      if (link) {
        if (event.metaKey || event.ctrlKey || event.shiftKey) { window.open(link.href, '_blank'); }
        else { window.location.href = link.href; }
        return;
      }
    }
    if (!event.target.closest('.ve-qa')) closeSheets(null);
  });
  document.addEventListener('keyup', function (event) { if (event.key === 'Escape') closeSheets(null); });
})();

/* featured-collection drag carousel (desktop), scoped to featured collection */
(function () {
  var CSS =
    '@media (min-width:750px){' +
    '.ve-carousel.product-grid{display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden;' +
    'scroll-snap-type:x proximity;gap:var(--grid-desktop-horizontal-spacing,32px);scrollbar-width:none;' +
    '-ms-overflow-style:none;margin:0;padding-bottom:1.4rem;scroll-behavior:smooth;}' +
    '.ve-carousel.product-grid::-webkit-scrollbar{display:none;}' +
    '.ve-carousel.is-drag{scroll-snap-type:none;scroll-behavior:auto;}' +
    '.ve-carousel .grid__item{flex:0 0 auto;width:clamp(260px,29vw,360px);max-width:none;' +
    'scroll-snap-align:start;margin:0 !important;}' +
    '.ve-carousel.is-drag,.ve-carousel.is-drag *{user-select:none;}' +
    '}';
  var injected = false;
  function injectCSS() { if (injected) return; injected = true; var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s); }
  function setup(grid) {
    if (grid.__veCar) return;
    grid.__veCar = true;
    injectCSS();
    grid.classList.add('ve-carousel');
    grid.setAttribute('data-cursor', 'drag');
    var down = false, startX = 0, startScroll = 0, moved = 0;
    grid.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      down = true; moved = 0; startX = e.clientX; startScroll = grid.scrollLeft;
      grid.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      grid.scrollLeft = startScroll - dx;
    });
    function end() { if (!down) return; down = false; grid.classList.remove('is-drag'); }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    grid.addEventListener('click', function (e) { if (moved > 8) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function initCarousels() {
    document.querySelectorAll('[data-id*="featured_collection"] .product-grid, [id*="featured_collection"] .product-grid').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCarousels);
  else initCarousels();
  document.addEventListener('shopify:section:load', initCarousels);
})();

/* micro-motion (pure CSS): nav/footer underline draws, red title underline, button tracking, + product-title dedupe fix */
(function () {
  var CSS = [
    '.header__menu-item{position:relative;}',
    '.header__menu-item::after{content:"";position:absolute;left:0;right:0;bottom:0.2rem;height:1px;background:currentColor;transform:scaleX(0);transform-origin:left center;transition:transform .5s cubic-bezier(.16,1,.3,1);}',
    '.header__menu-item:hover::after,.header__menu-item[aria-expanded="true"]::after{transform:scaleX(1);}',
    '.footer-block__details-content a,.footer__list-item>a,.list-menu__item--link{background-image:linear-gradient(currentColor,currentColor);background-size:0% 1px;background-position:left 100%;background-repeat:no-repeat;transition:background-size .5s cubic-bezier(.16,1,.3,1);}',
    '.footer-block__details-content a:hover,.footer__list-item>a:hover,.list-menu__item--link:hover{background-size:100% 1px;}',
    '.ve-card__title{display:inline;background-image:linear-gradient(var(--ve-red,#e10600),var(--ve-red,#e10600));background-size:0% 1px;background-position:left 100%;background-repeat:no-repeat;transition:background-size .45s cubic-bezier(.16,1,.3,1);}',
    '.ve-card:hover .ve-card__title{background-size:100% 1px;}',
    '.button:hover,.ve-gh__cta:hover{letter-spacing:0.3em;transition:letter-spacing .35s cubic-bezier(.16,1,.3,1),background-color .2s ease,color .2s ease;}',
    '.header__icon{transition:transform .3s cubic-bezier(.16,1,.3,1);}',
    '.header__icon:hover{transform:translateY(-2px);}',
    '.product__title > h1 + a{display:none !important;}',
    'a.product__title{text-decoration:none !important;}'
  ].join('');
  var s = document.createElement('style');
  s.textContent = CSS;
  (document.head || document.documentElement).appendChild(s);
})();
